import type { TenantSettings } from '../api/types';

/** Post-booking destination from `/settings.redirect.thank_you_booking`, if configured. */
export function thankYouUrl(settings: TenantSettings | null | undefined): string | null {
  const url = settings?.redirect?.thank_you_booking?.trim();
  if (!url) return null;
  try {
    const parsed = new URL(url, typeof location !== 'undefined' ? location.href : undefined);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:' ? parsed.toString() : null;
  } catch {
    return null;
  }
}

export function navigateTo(url: string, win: Pick<Window, 'location'> = window): void {
  win.location.assign(url);
}
